import {config} from "./config";
import {request} from "./request";

function getItems(data, cb, fail_cb) {
    request.get.call(this, config.apiList.accountWithdraws, data, cb, fail_cb)
}

var accountWithdrawApi = {
    getItems: getItems,
}

export {accountWithdrawApi}